// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pord-heading {\n    text-align: center !important;\n}\n\n.list-container {\n    margin-top: -10px !important;\n}", "",{"version":3,"sources":["webpack://src/components/DashBoard/Statistics/listStyles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".pord-heading {\n    text-align: center !important;\n}\n\n.list-container {\n    margin-top: -10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
